module.exports = __webpack_public_path__ + "img/companhia.35fd2fab.png";